<template>
	<jr-echarts ref="echartsRef" :options="chartOptions" :height="height" :width="width" />
</template>

<script>
	import JrEcharts from './index.vue'

	// 企业资质等级对比-柱状图
	export default {
		name: 'EnterpriseIndustryBarChart',
		components: {
			JrEcharts
		},
		props: {
			width: {
				type: String,
				default: '100%'
			},
			height: {
				type: String,
				default: '350px'
			},
			title: {
				type: String,
				default: ''
			},
			// 本企业数据（纵坐标）
			enterpriseSeriesData: {
				type: Array,
				default: () => []
			},
			// 行业平均数据（纵坐标）
			averageSeriesData: {
				type: Array,
				default: () => []
			},
			// 等级数据（横坐标）
			xAxisData: {
				type: Array,
				default: () => []
			}
		},
		data() {
			return {}
		},
		computed: {
			chartOptions() {
				return {
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'shadow'
						}
					},
					legend: {
						data: ['本企业', '行业平均'],
						top: 10,
						textStyle: {
							fontSize: 14
						}
					},
					grid: {
						left: '4%',
						right: '6%',
						bottom: '2%',
						top: '15%',
						containLabel: true
					},
					xAxis: {
						type: 'category',
						data: this.xAxisData,
						axisTick: {
							alignWithLabel: true
						},
						axisLabel: {
							color: '#666',
							fontSize: 14
						},
						splitLine: {
							// 显示X轴网格线
							show: true,
							lineStyle: {
								color: '#eee', // 网格线颜色
								type: 'border' // 网格线样式
							}
						},
						// 添加X轴名称
						name: '等级',
						nameLocation: 'end',
						nameGap: 5,
						nameTextStyle: {
							fontSize: 14
						}
					},
					yAxis: {
						type: 'value',
						minInterval: 2,
						min: 0,
						max: 12,
						axisLabel: {
							color: '#666',
							fontSize: 14
						},
						splitLine: {
							lineStyle: {
								type: 'border'
							}
						},
						// 添加Y轴名称
						name: '数量（个）',
						nameLocation: 'end',
						nameGap: 13,
						nameTextStyle: {
							fontSize: 14
						}
					},
					series: [
						{
							name: '本企业',
							type: 'bar',
							barWidth: '20%',
							itemStyle: {
								color: '#165dff',
								borderRadius: [5, 5, 0, 0]
							},
							data: this.enterpriseSeriesData
						},
						{
							name: '行业平均',
							type: 'bar',
							barWidth: '20%',
							itemStyle: {
								color: '#86909c',
								borderRadius: [5, 5, 0, 0]
							},
							data: this.averageSeriesData
						}
					]
				}
			}
		},
		methods: {}
	}
</script>

<style lang="scss" scoped></style>
